import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, useAttrs, watch } from "vue"
import { CURRENCIES, ICurrency } from "../../../constants/data"
import { ValidationObserver } from "vee-validate"
import ErrorMessage from "@/components/widgets/common/ErrorMessage.vue"

export type MoneyInputValue = {
  amount: string | null | number
  currency: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoneyInput',
  props: {
    value: null,
    label: null,
    required: { type: Boolean },
    labelEndAdornment: null
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }) {

const props = __props as {
  value?: MoneyInputValue | null
  label?: string
  required?: boolean
  labelEndAdornment?: string
}

const defaultCurrency = {
  en: "United States",
  flag: "🇺🇸",
  currency: "US Dollar",
  symbol: "$",
  currencyCode: "USD",
}





const selectedCurrency = ref<string | null>(null)

const form = ref<MoneyInputValue>({
  currency: "",
  amount: null,
})

const attrs = computed(() => {
  const { label, prependIcon, ...attrs } = useAttrs()
  return attrs
})

const getItemText = (item: ICurrency) => `${item.flag} ${item.en} (${item.currencyCode})`

const validationString = computed(() => {
  return props.required ? "required" : ""
})

const amountValidationProvider = ref<InstanceType<typeof ValidationObserver> | null>(null)

const currentErrors = computed(() => {
  return amountValidationProvider.value ? (amountValidationProvider.value as any).errors : []
})

const updateCurrency = (cn: ICurrency) => {
  form.value.currency = cn.currencyCode
  selectedCurrency.value = cn.currencyCode
}

const onChange = () => {
  const obj = { amount: form.value.amount, currency: form.value.currency }

  emit("input", obj)
}
const onDialCodeChange = (cn: string) => {
  if (!cn) return

  selectedCurrency.value = cn

  onChange()
}

const onDialCodeBlur = () => {
  if (form.value.currency) return

  if (props.value?.currency && selectedCurrency.value) {
    form.value.currency = props.value.currency
  } else {
    updateCurrency(defaultCurrency)
  }

  onChange()
}

watch(
  () => props.value,
  (value) => {
    if (!value?.amount && !value?.currency) {
      return updateCurrency(defaultCurrency)
    }

    if (value?.currency || value?.amount) {
      form.value = {
        ...form.value,
        ...value,
      }
      selectedCurrency.value = value?.currency
    }
  },
  { immediate: true, deep: true }
)

return { __sfc: true,defaultCurrency, emit, props, selectedCurrency, form, attrs, getItemText, validationString, amountValidationProvider, currentErrors, updateCurrency, onChange, onDialCodeChange, onDialCodeBlur, CURRENCIES, ErrorMessage }
}

})